import { __makeTemplateObject } from "tslib";
import React from "react";
import { FileTypeFolderIcon, FileTypeSheetsIcon, FileTypeWorkgroupIcon, FileTypeDashboardsIcon, FileTypeReportsIcon, FavoriteIcon, FileTypeFormsIcon, LinkIcon, NullIcon, } from "@smartsheet/lodestar-icons";
import { TreeItemType } from "../models/TreeItemType";
import DynamicView from "./icons/DynamicView";
import Projects from "./icons/Projects";
import styled from "@emotion/styled";
import { sizes } from "@smartsheet/lodestar-core";
export var getIconForContainerType = function (containerType) {
    var className = "containerTree__containerIcon";
    switch (containerType) {
        case TreeItemType.WORKSPACE:
            return React.createElement(FileTypeWorkgroupIcon, { className: className });
        case TreeItemType.DASHBOARD:
        case TreeItemType.SIGHT:
            return React.createElement(FileTypeDashboardsIcon, { className: className });
        case TreeItemType.SHEET:
            return React.createElement(FileTypeSheetsIcon, { className: className });
        case TreeItemType.REPORT:
            return React.createElement(FileTypeReportsIcon, { className: className });
        case TreeItemType.FOLDER:
            return React.createElement(FileTypeFolderIcon, { className: className });
        case TreeItemType.FAVORITE:
            return React.createElement(FavoriteIcon, { className: className });
        case TreeItemType.WORKAPP:
            return React.createElement(FileTypeWorkgroupIcon, { className: className });
        case TreeItemType.FORM:
            return React.createElement(FileTypeFormsIcon, { className: className });
        case TreeItemType.WWW:
            // This doesn't support custom favicons yet
            return React.createElement(LinkIcon, { className: className });
        case TreeItemType.PROJECTREGISTRY:
            return React.createElement(ProjectsIconStyled, { className: className });
        case TreeItemType.DYNAMICVIEW:
            return React.createElement(DynamicViewIconStyled, { className: className });
        case TreeItemType.COLLECTION:
        case TreeItemType.COLLECTIONS:
        case TreeItemType.CONTENT:
        case TreeItemType.CONTENT_LIBRARY:
        case TreeItemType.BLUEPRINTS:
        case TreeItemType.BLUEPRINT:
        case TreeItemType.INTAKE_SHEET:
        default:
            return React.createElement(NullIcon, { className: className });
    }
};
var ProjectsIconStyled = styled(Projects)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n"], ["\n    width: ", "px;\n    height: ", "px;\n"])), sizes.large, sizes.large);
export var DynamicViewIconStyled = styled(DynamicView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n"], ["\n    width: ", "px;\n    height: ", "px;\n"])), sizes.large, sizes.large);
var templateObject_1, templateObject_2;
//# sourceMappingURL=getIcons.js.map